import { Link } from 'react-router-dom';

const Services = () => {
    return ( 
        <div className="section techwix-service-section-03" style={{backgroundImage: "url(assets/images/bg/service-bg3.jpg)"}}>
            <div className="container">
                <div className="service-wrap-03">
                    <div className="row" style={{textAlign: "left"}}>
                        <div className="col-xl-3 col-md-6">
                            <div className="service-item-03">
                                <div className="service-img">
                                    <img src="assets/images/ser-icon22.png" alt="" />
                                </div>
                                <div className="service-content">
                                    <h3 className="title"><Link to="/service">Software Development</Link></h3>
                                    <p>We create software that ranges from fleet management to inventory management to full-fledged ERP packages.</p>
                                    <div className="read-more">
                                        <Link to="/service"><i className="fas fa-plus"></i> Read More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="service-item-03">
                                <div className="service-img">
                                    <img src="assets/images/ser-icon10.png" alt="" />
                                </div>
                                <div className="service-content">
                                    <h3 className="title"><Link to="/service">IT Consultancy & solution</Link></h3>
                                    <p>Accelerate your business with our IT consultancy and solutions expertise. Unlock growth, innovation and future success.</p>
                                    <div className="read-more">
                                        <Link to="/service"><i className="fas fa-plus"></i> Read More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="service-item-03">
                                <div className="service-img">
                                    <img src="assets/images/ser-icon11.png" alt="" />
                                </div>
                                <div className="service-content">
                                    <h3 className="title"><Link to="/service">Cloud managed services</Link></h3>
                                    <p>Elevate your business with our Managed Cloud Services: Experience seamless scalability, security & support.</p>
                                    <div className="read-more">
                                        <Link to="/service"><i className="fas fa-plus"></i> Read More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="service-item-03">
                                <div className="service-img">
                                    <img src="assets/images/counter-2.png" alt="" />
                                </div>
                                <div className="service-content">
                                    <h3 className="title"><Link to="/service">Data Science & Analysis</Link></h3>
                                    <p>Get the predictive insights and risk analytics to make your global supply chain faster, smarter, leaner, and more sustainable</p>
                                    <div className="read-more">
                                        <Link to="/service"><i className="fas fa-plus"></i> Read More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default Services;